import React, { useState } from 'react';
import { Link } from 'react-router';
import Header from '../Header';
import Sidebar from '../Sidebar';
import { useAuthStore } from '../../store/useAuthStore';
import Loader from '../loader/Loader';

export default function AddUser() {
    const [formData, setFormData] = useState({
        username: '',
        email: '',
        fullName: '',
        avatar: null,
        role: '',
        password: '',
        confirmPassword: '',
        address: {
            phone: '',
            streetAddress: '',
            apartmentOrSuite: '',
            city: '',
            state: '',
            zipCode: '',
            country: 'United States',
        },
        permissions: [],
    });
    const { registerUser, loading } = useAuthStore()
    const [previewUrl, setPreviewUrl] = useState(null);


    const handleChange = (e) => {
        const { name, value, type, checked, files } = e.target;

        if (type === 'file') {
            setFormData({ ...formData, [name]: files[0] });
            setPreviewUrl(URL.createObjectURL(files[0]));
        } else if (type === 'checkbox') {
            const updatedPermissions = checked
                ? [...formData.permissions, value]
                : formData.permissions.filter(p => p !== value);
            setFormData({ ...formData, permissions: updatedPermissions });
        } else if (name.startsWith('address.')) {
            const field = name.split('.')[1];
            setFormData({
                ...formData,
                address: {
                    ...formData.address,
                    [field]: value
                }
            });
        } else {
            setFormData({ ...formData, [name]: value });
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            await registerUser(formData)
        } catch (error) {
            console.log(error)
        }
    };

    return (
        <div id="dashboard-root" className="flex min-h-[1000px] w-full">
            <Sidebar />
            {/* <Loader loading={loading} /> */}
            <main id="main-content" className="flex-1 px-10 py-8">
                <Header title="Add User" />
                <form onSubmit={handleSubmit}>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6 p-8 bg-white">
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">Username<span className="text-red-500 ml-1">*</span></label>
                                <input type="text" name="username" value={formData.username} onChange={handleChange} className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary-500" />
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">Full Name<span className="text-red-500 ml-1">*</span></label>
                                <input type="text" name="fullName" value={formData.fullName} onChange={handleChange} className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary-500" />
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">Email<span className="text-red-500 ml-1">*</span></label>
                                <input type="email" name="email" value={formData.email} onChange={handleChange} className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary-500" />
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">Phone</label>
                                <input type="tel" name="address.phone" value={formData.address.phone} onChange={handleChange} className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary-500" />
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">Street Address</label>
                                <input type="text" name="address.streetAddress" value={formData.address.streetAddress} onChange={handleChange} className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary-500" />
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">Apartment/Suite</label>
                                <input type="text" name="address.apartmentOrSuite" value={formData.address.apartmentOrSuite} onChange={handleChange} className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary-500" />
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">City</label>
                                <input type="text" name="address.city" value={formData.address.city} onChange={handleChange} className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary-500" />
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">State</label>
                                <input type="text" name="address.state" value={formData.address.state} onChange={handleChange} className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary-500" />
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">Zip Code</label>
                                <input type="text" name="address.zipCode" value={formData.address.zipCode} onChange={handleChange} className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary-500" />
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">Country</label>
                                <input type="text" name="address.country" value={formData.address.country} onChange={handleChange} className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary-500" />
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">Role<span className="text-red-500 ml-1">*</span></label>
                                <select name="role" value={formData.role} onChange={handleChange} className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary-500">
                                    <option value="">Select Role</option>
                                    <option value="admin">Admin</option>
                                    <option value="user">User</option>
                                </select>
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">Password<span className="text-red-500 ml-1">*</span></label>
                                <input type="password" name="password" value={formData.password} onChange={handleChange} className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary-500" />
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">Confirm Password<span className="text-red-500 ml-1">*</span></label>
                                <input type="password" name="confirmPassword" value={formData.confirmPassword} onChange={handleChange} className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary-500" />
                            </div>
                        </div>

                        <div className="mb-6">
                            <label className="block text-sm font-medium text-gray-700 mb-1">Profile Picture</label>
                            <div className="border-2 border-dashed border-gray-300 rounded-lg p-6 text-center">
                                <i className="fa-solid fa-cloud-arrow-up text-gray-400 text-2xl mb-2"></i>
                                <p className="text-sm text-gray-500">Drag and drop your image here, or click to browse</p>
                                <input type="file" name="avatar" className="hidden" onChange={handleChange} />
                                <button type="button" onClick={() => document.querySelector('input[name="avatar"]').click()} className="mt-2 bg-white border border-gray-300 rounded-lg px-4 py-2 text-sm font-medium text-gray-700">Browse Files</button>
                            </div>

                            {previewUrl && (
                                <img src={previewUrl} alt="Preview" className="mt-2 h-20" />
                            )}
                            <div className="border-t pt-8 flex justify-end space-x-3">
                                <Link to="/users" className="px-4 py-2 border border-gray-300 rounded-lg text-gray-700" id="cancel-category-modal">Cancel</Link>
                                <button type="submit" className="px-4 py-2 bg-primary-600 text-white rounded-lg">Submit</button>
                            </div>
                        </div>


                    </div>
                </form>
            </main>
        </div>
    );
}
